import { DepartmentDto, GrantRole } from "../../../../autogen/bff-api";
import { departmentsAreEnabled } from "../../../../common/departments/departmentVisibility";
import { departmentAssignableRoles } from "./useDepartmentRoles";

const ADMINISTER_ROLES = "AdministerRoles";
const ASSIGN_ADMIN_ROLE = "AssignAdminRole";

type OrgWithDepartments = { canManageUsers: boolean; departments?: DepartmentDto[] };

const allows = (department: DepartmentDto | undefined, operation: string): boolean =>
  department?.operations?.some((o) => o.operation === operation && o.allowed) ?? false;

const departmentIn = (org: OrgWithDepartments, departmentId: string | null | undefined) =>
  (org.departments ?? []).find((d) => d.id === departmentId);

export const administersRolesIn = (org: OrgWithDepartments, departmentId: string | null | undefined): boolean =>
  org.canManageUsers || allows(departmentIn(org, departmentId), ADMINISTER_ROLES);

export const administersSomeDepartment = (org: OrgWithDepartments): boolean =>
  (org.departments ?? []).some((d) => d.active && allows(d, ADMINISTER_ROLES));

export const administersAdminRoleIn = (org: OrgWithDepartments, departmentId: string | null | undefined): boolean =>
  org.canManageUsers || allows(departmentIn(org, departmentId), ASSIGN_ADMIN_ROLE);

export const administersDepartmentRole = (
  org: OrgWithDepartments,
  departmentId: string | null | undefined,
  role: GrantRole,
): boolean =>
  role === GrantRole.Admin ? administersAdminRoleIn(org, departmentId) : administersRolesIn(org, departmentId);

export const assignableDepartmentRoles = (
  org: OrgWithDepartments,
  departmentId: string | null | undefined,
): GrantRole[] =>
  departmentAssignableRoles.filter((role) => administersDepartmentRole(org, departmentId, role));

export const reachesAccessManagement = (org: OrgWithDepartments): boolean =>
  org.canManageUsers || (departmentsAreEnabled() && administersSomeDepartment(org));
